import { useCallback, useMemo, useEffect } from 'react'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useFormikContext, useField } from 'formik'
import { useSelector } from 'react-redux'
import { ISource, selectAllSources } from '@user/store/sources'

type Props = {
  required: boolean
  name: string
}

export function useData(props: Props) {
  const { required, name } = props
  const {
    setFieldValue,
    isSubmitting,
    values: { leadSourceId },
  } = useFormikContext<IAddOpportunityFormModel>()

  const [{}, { error, touched }] = useField<string>({
    name,
    validate: (value) => {
      if (required && !value) {
        return 'Required'
      }
    },
  })

  const showError = Boolean(error && touched)
  const helperText = showError ? error : ''

  const leadSources = useSelector(selectAllSources)

  const options = useMemo(() => leadSources, [leadSources])

  const getOptionLabel = useCallback((option: ISource) => option?.name, [])

  const getId = useCallback((option: ISource) => {
    return String(option.id)
  }, [])

  useEffect(() => {
    if (!leadSourceId && required && options?.length == 1) {
      setFieldValue(name, options[0].id)
    }
  }, [leadSourceId, required, setFieldValue])

  const initialOption = useMemo(() => {
    if (leadSourceId) {
      const value = options.find((x) => x.id == leadSourceId)

      if (value) return value
    }
    return null
  }, [options, leadSourceId])

  return {
    getOptionLabel,
    getId,
    options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
  }
}
